// extracted by mini-css-extract-plugin
module.exports = {"banner_contianer":"styles_banner_contianer__OAz5i","desktop_header":"styles_desktop_header__nGERQ"};